import styled from 'styled-components';

export const MarginDiv = styled.div`
  margin-left: 130px;
`;
